class ConfigurationManager {
    static set environment(environment) {
        // Only embed explicitly whitelisted non-sensitive env vars in the bundle
        const allowedKeys = [
            'REACT_APP_NUXEO_HOST',
            'REACT_APP_NUXEO_PORT',
            'REACT_APP_WBCP_HOST',
            'REACT_APP_WBCP_PORT'
        ];

        this._environment = {};
        for (let key of allowedKeys) {
            if (Object.prototype.hasOwnProperty.call(environment, key)) {
                this._environment[key] = environment[key];
            }
        }
    }

    static getProperty(name) {
        return this._environment['REACT_APP_' + name];
    }
}

export default ConfigurationManager;